export default __webpack_public_path__ + "resources/icons/n411-f468.png";